module.exports = __webpack_public_path__ + "aeffbfd69ae0d9f12603e0c0e491e70c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/school.png
// module id = 1107
// module chunks = 0